import { render, staticRenderFns } from "./moneyPlan.vue?vue&type=template&id=a232f94c&scoped=true"
import script from "./moneyPlan.vue?vue&type=script&lang=js"
export * from "./moneyPlan.vue?vue&type=script&lang=js"
import style0 from "./moneyPlan.vue?vue&type=style&index=0&id=a232f94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a232f94c",
  null
  
)

export default component.exports